import { z } from 'zod';

import { userSchema } from '../../user/types';

export const customerUserSchema = z.object({
    customerUser_id: z.number(),
    customer_id: z.number(),
    user_id: z.number(),
    deleted: z.boolean(),
    user: userSchema,
});

export type TCustomerUser = z.infer<typeof customerUserSchema>;
